import { FC } from 'react';
import { TextFieldElement, TextFieldElementProps, useWatch } from 'react-hook-form-mui';
import { FieldLabel } from 'src/presentations/components/molecules/fields/FieldLabel';
import { useFieldMaterialUIStyles } from 'src/presentations/components/molecules/fields/useFieldMaterialUIStyles';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .MuiFormLabel-root': {
    fontSize: '16px',

    [theme.breakpoints.down(1520)]: {
      fontSize: '14px',
    },
  },
  '& .MuiInputBase-input ': {
    fontSize: '16px',

    [theme.breakpoints.down(1520)]: {
      fontSize: '14px',
    },
  },
}));

interface IWorkflowFieldProps extends TextFieldElementProps {
  hideFieldLabel?: boolean;
}

export const WorkflowTextField: FC<IWorkflowFieldProps> = (props) => {
  const { fullWidth = true, size = 'small', label, children, name, hideFieldLabel, disabled, ...rest } = props;
  const { classes, cx } = useFieldMaterialUIStyles();

  return (
    <FieldLabel label={hideFieldLabel ? null : label}>
      <StyledBox className='relative'>
        <TextFieldElement
          name={name}
          label={hideFieldLabel ? label : null}
          className={cx({ [classes.shortWidth]: !fullWidth }, classes.inputField)}
          fullWidth
          size={size}
          disabled={disabled}
          {...rest}
        />
        {children}
      </StyledBox>
    </FieldLabel>
  );
};

export const WorkflowNumericField: FC<IWorkflowFieldProps> = (props) => {
  const { fullWidth = true, size = 'small', label, children, name, hideFieldLabel, disabled, ...rest } = props;
  const { classes, cx } = useFieldMaterialUIStyles();

  return (
    <FieldLabel label={hideFieldLabel ? null : label}>
      <StyledBox className='relative'>
        <TextFieldElement
          className={cx({ [classes.shortWidth]: !fullWidth }, classes.inputField)}
          fullWidth
          size={size}
          name={name}
          inputProps={{ inputMode: 'decimal', min: '0', step: 'any' }}
          label={hideFieldLabel ? label : null}
          type='number'
          disabled={disabled}
          {...rest}
        />
        {children}
      </StyledBox>
    </FieldLabel>
  );
};

export const WorkflowTextArea: FC<IWorkflowFieldProps> = (props) => {
  const { fullWidth = true, size = 'small', label, placeholder, children, name, rows, disabled, ...rest } = props;
  const { classes, cx } = useFieldMaterialUIStyles();

  return (
    <FieldLabel label={label}>
      <StyledBox className='relative'>
        <TextFieldElement
          name={name}
          className={cx({ [classes.shortWidth]: !fullWidth }, classes.inputField)}
          multiline
          rows={rows || 6}
          fullWidth
          size={size}
          label={placeholder || 'Input Description'}
          placeholder={placeholder}
          disabled={disabled}
          {...rest}
        />
        {children}
      </StyledBox>
    </FieldLabel>
  );
};
